import React from 'react';
import LoaderRR from './LoaderMagicVision.svg'

import './styles.scss';

function Loader(props) {
  return (
    <div className="loader-background" hidden={props.hidden}>
      <div className="loader">
        <img src={LoaderRR} alt='loading' width={'100%'}/>
      </div>
    </div>
  );
}
export default Loader;